'use strict';

import {Component, EventEmitter, ElementRef} from '@angular/core';
import {CORE_DIRECTIVES} from '@angular/common';
import DropKick from 'Robdel12/DropKick';
import 'Robdel12/DropKick/build/css/dropkick.css!css';

@Component({
  selector: 'dropdown',
  events: ['change'],
  template: `
    <select (change)=onChange($event.target.value)>
      <ng-content></ng-content>
    </select>
  `,
  directives: [CORE_DIRECTIVES],
  styles: [`
    :host .dk-select{max-width:100%;font-family:Montserrat,sans-serif;font-size:.929em;min-width:100px;width:auto}:host .dk-selected:after{display:none}:host .dk-selected{color:#263238;border-color:rgba(38,50,56,0.5);padding:0.15em 0.6em 0.2em 0.5em;border-radius:2px}:host .dk-select-open-down .dk-selected,:host .dk-selected:focus,:host .dk-selected:hover{border-color:#0033a0;color:#0033a0}:host .dk-selected:before{border-top-color:#263238;border-width:.35em .35em 0}:host .dk-select-open-down .dk-selected:before,:host .dk-select-open-up .dk-selected:before{border-bottom-color:#0033a0}:host .dk-select-multi:focus .dk-select-options,:host .dk-select-open-down .dk-select-options,:host .dk-select-open-up .dk-select-options{border-color:rgba(38,50,56,0.2)}:host .dk-select-options .dk-option-highlight{background:#ffffff}:host .dk-select-options{margin-top:0.2em;padding:0;border-radius:2px;box-shadow:0px 2px 4px 0px rgba(34,36,38,0.12),0px 2px 10px 0px rgba(34,36,38,0.08) !important}:host .dk-option{color:#263238;padding:0.16em 0.6em 0.2em 0.5em}:host .dk-option:hover{background-color:rgba(38,50,56,0.12)}:host .dk-option:focus{background-color:rgba(38,50,56,0.12)}:host .dk-option-selected{background-color:rgba(0,0,0,0.05) !important}
  `]
})
@Reflect.metadata('parameters', [[ElementRef]])
export class DropDown {
  constructor(elem) {
    this.change = new EventEmitter();
    this.elem = elem.nativeElement;
  }

  ngAfterContentInit() {
    this.inst = new DropKick(this.elem.firstElementChild, {autoWidth: true});
  }

  onChange(value) {
    this.change.next(value);
  }

  destroy() {
    this.inst.dispose();
  }
}
